/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespRequestHoldToast_item$ref = any;
export type PdpRespRequestHoldToastLoader_item$ref = any;
export type PdpRespRequestHoldToastLoader_item = {
    readonly " $fragmentRefs": PdpRespRequestHoldToast_item$ref;
    readonly " $refType": PdpRespRequestHoldToastLoader_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespRequestHoldToastLoader_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespRequestHoldToast_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'bb401348b8603ec3e293f1cf48632982';
export default node;
